import { FlagTypes } from '@agoda/layout';

export const clientVersion = '1.0';
export const enUsCulture = 'en-us';
export const zhCnCulture = 'zh-cn';
export const defaultLanguage = { languageId: 1, cultureCode: 'en-us', flag: FlagTypes.US, name: 'English', isSuggested: true, isCurrencyBehind: false, isRtl: false };
export const defaultLanguageCN = { languageId: 9, cultureCode: 'zh-cn', flag: FlagTypes.CN, name: '简体中文', isSuggested: true, isCurrencyBehind: false, isRtl: false };

export enum ApplicationName {
    Unknown = 0,
    MobileApp = 1,
    MobileWeb = 2,
    DesktopWeb = 3,
}
